import {
  Flex,
  Table,
  Button,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useToast,
  Tooltip,
} from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { EditIcon, AddIcon, DeleteIcon } from '@chakra-ui/icons';
import AddModal from './addModal';
import EditModal from './editModal';
import PopDelete from './deletePopover';
import OperationLocationAPI from '../../../../api/operationlocation';
import BullionConfigApi from 'api/bullionconfig';
import { MetalTypesOptions } from 'config/constant';
import { usePermissions } from 'contexts/PermissionContext';
import { Modules } from 'config/constant';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import TableWrapper from 'components/tableWrapper/tableWrapper';

export default function TableData(props) {
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const [isError, setIsError] = useState('');
  const [list, setList] = useState([]);
  const [operationList, setOperationList] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [listTotal, setListTotal] = useState(2);
  const { getPermissionsForModule } = usePermissions();
  const [bullionConfigPermissions, setBullionConfigPermissions] =
    useState(null);

  // const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const fetchList = async () => {
    try {
      setLoading(true);
      let response = await BullionConfigApi.List({
        currentPage,
        itemsPerPage,
        sort: 'name:asc',
        searchTerm,
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200 && response?.data?.list?.length > 0) {
        setList(response?.data?.list);
        setListTotal(response?.data?.total);
      } else {
        setList(null);
        setListTotal(0);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    const bullionConfigPermissions = getPermissionsForModule([
      Modules.BullionConfig,
    ]);
    setBullionConfigPermissions(bullionConfigPermissions);
    fetchList();
  }, [currentPage, searchTerm, getPermissionsForModule]);

  // const DeleteConfig = async (id) => {
  //   try {
  //     setLoading(true);
  //     let response = await BullionConfigApi.Delete(id);
  //     response = response.data;
  //     setLoading(false);
  //     if (response.status_code === 200) {
  //       fetchList();
  //     } else {
  //       setList(null);
  //       setListTotal(0);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const FetchOperationLocationList = async () => {
    try {
      let response = await OperationLocationAPI.List({
        currentPage: 1,
        itemsPerPage: 100,
        sort: 'name:asc',
      });
      response = response.data;
      if (response.status_code === 200 && response?.data?.list?.length > 0) {
        setOperationList(response?.data?.list);
      } else {
        setOperationList([]);
      }
    } catch (err) {
      console.log(err);
      setOperationList([]);
    }
  };
  useEffect(() => {
    FetchOperationLocationList();
  }, []);

  if (!bullionConfigPermissions?.read) {
    return <NoPermissionsMessage module={Modules.BullionConfig} />;
  }
  return (
    <Flex height='100%' mt='8rem' direction='column'>
      <Flex
        direction={{ sm: 'column', md: 'row' }}
        px={5}
        mb='20px'
        width='100%'
        gap={10}
      >
        <Flex ml='auto'>
          <Tooltip
            label={
              !bullionConfigPermissions?.create
                ? 'You do not have permission to add'
                : undefined
            }
            placement='top'
            shouldWrapChildren
          >
            <AddModal
              Icon={<AddIcon />}
              operationList={operationList}
              head={'Add'}
              func={fetchList}
              disabled={!bullionConfigPermissions?.create}
            />
          </Tooltip>
        </Flex>
      </Flex>

      <TableWrapper
        list={list}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        listTotal={listTotal}
        itemsPerPage={itemsPerPage}
        isError={isError}
      >
        <Table variant='striped' color='gray.500' mb='24px'>
          <Thead>
            <Tr>
              <Th pe='1px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Sr.no
                </Flex>
              </Th>
              <Th pe='5px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Type
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Sell Price % Deviation
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Buy Price % Deviation
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Exchange Price % Deviation
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Customer Max Buy
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Customer Max Sell
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Threshold Sell
                </Flex>
              </Th>
              <Th pe='5px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Threshold Buy
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Unit
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Status
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Actions
                </Flex>
              </Th>
            </Tr>
          </Thead>

          <Tbody>
            {list?.map((obj, index) => {
              return (
                <Tr key={obj.id}>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='5px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {(currentPage - 1) * 10 + (index + 1)}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {
                          MetalTypesOptions.find(
                            (option) => option.value === obj?.type
                          )?.label
                        }
                      </Text>
                    </Flex>
                  </Td>
                  {/* <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.operation_location}
                      </Text>
                    </Flex>
                  </Td> */}
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='5px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.sell_price_percentage_deviation}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='5px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.buy_price_percentage_deviation}
                      </Text>
                    </Flex>
                  </Td>

                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.exchange_price_percentage_deviation}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.customer_max_buy}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.customer_max_sell}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.threshold_sell}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='5px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.threshold_buy}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.unit}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Text
                      size='sm'
                      fontWeight='700'
                      color={obj.is_active === true ? 'green' : { textColor }}
                    >
                      {obj.is_active === true ? 'ACTIVE' : 'INACTIVE'}
                    </Text>
                  </Td>
                  <Td>
                    <Flex justify='space-around'>
                      <Tooltip
                        label={
                          !bullionConfigPermissions.update
                            ? 'You do not have permission to edit'
                            : undefined
                        }
                        placement='top'
                        shouldWrapChildren
                      >
                        <EditModal
                          Icon={<EditIcon />}
                          head={'Edit Bullion Config'}
                          initialData={obj}
                          id={obj.id}
                          func={fetchList}
                          disabled={!bullionConfigPermissions.update}
                        />
                      </Tooltip>
                      {/* {obj.is_active === true ? (
                        <PopDelete
                          Icon={<DeleteIcon />}
                          button={
                            <Button
                              colorScheme='red'
                              onClick={DeleteConfig}
                              value={obj.id}
                              disabled={true}>
                              Delete
                            </Button>
                          }
                        />
                      ) : (
                        'Disabled'
                      )} */}
                    </Flex>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableWrapper>
    </Flex>
  );
}
